import { render, staticRenderFns } from "./CampaignsFiltersDate.vue?vue&type=template&id=0b84a16f&scoped=true"
import script from "./CampaignsFiltersDate.vue?vue&type=script&lang=ts"
export * from "./CampaignsFiltersDate.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsFiltersDate.vue?vue&type=style&index=0&id=0b84a16f&prod&lang=scss&scoped=true"
import style1 from "./CampaignsFiltersDate.vue?vue&type=style&index=1&id=0b84a16f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84a16f",
  null
  
)

export default component.exports